@if (!companionMode) {
  @if (!(breakpointUtils.smallScreen$ | async)) {
    <se-fe-card
      class="cart-item"
      [ngClass]="{
        'cart-item--slideout': !checkoutPage,
        'cart-item--bundle': checkoutPage && isBundleGroup(),
      }">
      <section
        class="image-wrapper"
        [ngClass]="{'image-wrapper--bundle': isBundleGroup()}">
        <ng-container *ngTemplateOutlet="cartItemImageTemplate"></ng-container>
      </section>
      <section class="cart-item__details item-details">
        <div class="item-details__name">{{ displayName() }}</div>
        @if (showParticipantName()) {
          <div class="item-details__participant-name">
            <span>For&nbsp;{{ item().references?.participant?.name }}</span>
          </div>
        }
        <div class="item-details__specs">
          @if (isBundleGroup()) {
            @for (line of bundleGroupLines(); track $index) {
              <div class="bundle-line">
                {{ line }}
              </div>
            }
          } @else {
            <span class="spec">{{ specsLabel() }}</span>
          }
        </div>
        @if (editable) {
          <div class="item-details__form">
            <form [formGroup]="cartItemForm" class="cart-item-form">
              <input type="hidden" formControlName="id" />
              <input type="hidden" formControlName="productId" />
              <input type="hidden" formControlName="name" />
              <span class="quantity" [ngClass]="{hidden: hideItemQuantity()}">
                <label for="num_quantity" class="quantity__label">
                  Quantity
                </label>
                <!--suppress XmlDuplicatedId -->
                <se-fe-form-field-quantity
                  formControlName="quantity"
                  class="quantity__control"
                  id="num_quantity"
                  (addClick)="updateQuantity()"
                  (removeClick)="updateQuantity()"
                  [seFeDataMax]="
                    quantityStepperMax
                  "></se-fe-form-field-quantity>
              </span>
              <span class="remove">
                <se-fe-button
                  class="remove__button"
                  seFeDataEmphasis="low"
                  (click)="removeItem()">
                  Remove
                </se-fe-button>
              </span>
            </form>
          </div>
        }
        @if (checkoutPage) {
          <span>
            <strong>Quantity:</strong>
            {{ item().quantity }}
          </span>
          <div class="item-details__checkout-price">
            <span class="price">{{ displayPrice() | currency }}</span>
          </div>
        }
      </section>

      @if (!checkoutPage) {
        <section class="cart-item__price price-display">
          <span class="price">{{ displayPrice() | currency }}</span>
        </section>
      }
    </se-fe-card>
  } @else {
    <se-fe-card
      class="cart-item cart-item--small"
      [ngClass]="{
        'cart-item--slideout': !checkoutPage,
        'cart-item--bundle': checkoutPage && isBundleGroup(),
      }">
      <div class="cart-item__info info">
        <section
          class="info__image image-wrapper"
          [ngClass]="{'image-wrapper--bundle': isBundleGroup()}">
          <ng-container
            *ngTemplateOutlet="cartItemImageTemplate"></ng-container>
        </section>
        <section class="info__details item-details">
          <span class="item-details__name">{{ displayName() }}</span>
          <div class="item-details__specs">
            @if (isBundleGroup()) {
              @for (line of bundleGroupLines(); track $index) {
                <div class="bundle-line">
                  {{ line }}
                </div>
              }
            } @else {
              <span class="spec">{{ specsLabel() }}</span>
            }
          </div>
          <span class="item-text__price price">
            {{ displayPrice() | currency }}
          </span>
        </section>
      </div>
      @if (editable) {
        <div class="cart-item__form">
          <form [formGroup]="cartItemForm" class="cart-item-form">
            <input type="hidden" formControlName="id" />
            <input type="hidden" formControlName="productId" />
            <span class="quantity" [ngClass]="{hidden: hideItemQuantity()}">
              <label for="num_quantity" class="quantity__label">Quantity</label>
              <!--suppress XmlDuplicatedId -->
              <se-fe-form-field-quantity
                formControlName="quantity"
                class="quantity__control"
                id="num_quantity"
                (addClick)="updateQuantity()"
                (removeClick)="updateQuantity()"
                [seFeDataMax]="quantityStepperMax"></se-fe-form-field-quantity>
            </span>
            <span
              class="remove"
              [ngClass]="{
                remove__margin: !hideItemQuantity(),
              }">
              <se-fe-button
                class="remove__button"
                seFeDataEmphasis="low"
                (click)="removeItem()">
                Remove
              </se-fe-button>
            </span>
          </form>
        </div>
      }
    </se-fe-card>
  }
} @else {
  @if (!(breakpointUtils.smallScreen$ | async)) {
    <se-fe-card class="companion-cart-item">
      <section class="companion-cart-item__header item-header">
        <h3 class="item-header__name">
          {{ displayName() }}
        </h3>
        <span class="item-header__price">Price</span>
        <span class="item-header__quantity">Quantity</span>
      </section>
      <section class="companion-cart-item__details item-details">
        <div class="item-details__product">
          <section
            class="image-wrapper"
            [ngClass]="{'image-wrapper--bundle': isBundleGroup()}">
            <ng-container
              *ngTemplateOutlet="cartItemImageTemplate"></ng-container>
          </section>
          <div class="item-details__participant-name-specs">
            @if (showParticipantName()) {
              <div class="item-details__participant-name">
                <span>For&nbsp;{{ item().references?.participant?.name }}</span>
              </div>
            }
            <div class="item-details__specs">
              @if (isBundleGroup()) {
                @for (line of bundleGroupLines(); track $index) {
                  <div class="bundle-line">
                    {{ line }}
                  </div>
                }
              } @else {
                <span class="spec">{{ specsLabel() }}</span>
              }
            </div>
          </div>
        </div>
        <div
          class="cart-item__price price-display companion-cart-item__price-cell">
          <span class="price">{{ displayPrice() | currency }}</span>
        </div>
        <div class="companion-cart-item__quantity-cell item-details__form">
          @if (editable && !hideItemQuantity()) {
            <form [formGroup]="cartItemForm" class="cart-item-form">
              <input type="hidden" formControlName="id" />
              <input type="hidden" formControlName="productId" />
              <input type="hidden" formControlName="name" />
              <span class="quantity">
                <!--suppress XmlDuplicatedId -->
                <se-fe-form-field-quantity
                  formControlName="quantity"
                  class="quantity__control"
                  id="num_quantity"
                  seFeDataLabel="Quantity"
                  (addClick)="updateQuantity()"
                  (removeClick)="updateQuantity()"
                  [seFeDataMax]="
                    quantityStepperMax
                  "></se-fe-form-field-quantity>
              </span>
            </form>
          } @else {
            <span class="quantity-only">
              {{ quantityControl.value }}
            </span>
          }
        </div>
        <span class="companion-cart-item__remove-cell remove">
          <se-fe-icon-button (click)="removeItem()">
            <se-fe-icon
              seFeDataName="trash"
              seFeDataAriaLabel="Delete item"></se-fe-icon>
          </se-fe-icon-button>
        </span>
      </section>
    </se-fe-card>
  } @else {
    <se-fe-card class="companion-cart-item companion-cart-item--small">
      <section class="companion-small__info">
        <section
          class="image-wrapper"
          [ngClass]="{'image-wrapper--bundle': isBundleGroup()}">
          <ng-container
            *ngTemplateOutlet="cartItemImageTemplate"></ng-container>
        </section>
        <div class="companion-small__details">
          <div class="item-details__name">{{ displayName() }}</div>
          @if (showParticipantName()) {
            <div class="item-details__participant-name">
              <span>For&nbsp;{{ item().references?.participant?.name }}</span>
            </div>
          }
          <div class="item-details__specs">
            @if (isBundleGroup()) {
              @for (line of bundleGroupLines(); track $index) {
                <div class="bundle-line">
                  {{ line }}
                </div>
              }
            } @else {
              <span class="spec">{{ specsLabel() }}</span>
            }
          </div>
        </div>
      </section>
      <section class="companion-small__controls">
        <div class="cart-item__price price-display companion-small__price">
          <span class="price">{{ displayPrice() | currency }}</span>
        </div>
        <div class="companion-small__actions">
          <div class="companion-small__quantity item-details__form">
            @if (editable && !hideItemQuantity()) {
              <form [formGroup]="cartItemForm" class="cart-item-form">
                <input type="hidden" formControlName="id" />
                <input type="hidden" formControlName="productId" />
                <input type="hidden" formControlName="name" />
                <span class="quantity">
                  <label for="num_quantity" class="quantity__label">
                    Quantity
                  </label>
                  <!--suppress XmlDuplicatedId -->
                  <se-fe-form-field-quantity
                    formControlName="quantity"
                    class="quantity__control"
                    id="num_quantity"
                    seFeDataLabel="Quantity"
                    (addClick)="updateQuantity()"
                    (removeClick)="updateQuantity()"
                    [seFeDataMax]="
                      quantityStepperMax
                    "></se-fe-form-field-quantity>
                </span>
              </form>
            } @else {
              <span class="quantity-only">
                {{ quantityControl.value }}
              </span>
            }
          </div>
          @if (editable) {
            <span class="companion-small__remove remove">
              <se-fe-icon-button (click)="removeItem()">
                <se-fe-icon
                  seFeDataName="trash"
                  seFeDataAriaLabel="Delete item"></se-fe-icon>
              </se-fe-icon-button>
            </span>
          }
        </div>
      </section>
    </se-fe-card>
  }
}

<ng-template #cartItemImageTemplate>
  @if (isBundleGroup()) {
    <div class="bundle-preview">
      <img
        seFeHeaderVisual
        class="bundle-preview__image"
        [src]="bundlePreviewImage().src"
        alt="{{ bundlePreviewImage().alt }}" />
    </div>
  } @else {
    <img
      seFeHeaderVisual
      class="image"
      [src]="cartItemImage().src"
      alt="{{ cartItemImage().alt }}" />
  }
</ng-template>
